<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<br/><p style="text-indent:00em;">To Davina, who has led an extraordinary life.</p>
<br/><p style="text-indent:00em;">To my long-suffering husband who spent many hours alone while I focused on my characters instead of him.</p>
<br/><p style="text-indent:00em;">To my friends who read and re-read the various versions of this novel.</p>
<br/><p style="text-indent:00em;">To the members of DWG3, you know who are, who supported and encouraged me throughout the long writing process. I’d never have finished the book without you.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?51e611a2